import { ColorBoundary } from "..";
import { get_unique_values } from "../../../../misc/array";
import * as MathHelper from "../../../../misc/math";
import { ColorBoundaryContainer } from "../containers/ColorBoundaryContainer";
export class ColorCalculator {
    constructor() {
        this.numeric_values = [];
        this.categorical_values = [];
        this.edge_count = 0;
        this.colors = [];
        this.boundaries = new ColorBoundaryContainer();
        this.color_map = () => '';
        this.selected_field = "";
        this.keysToFormat = ['Price', 'Val', 'Land Val', 'Bld Val', 'XF Val', 'Heat Area', 'Eff Area'];
    }
    get values() {
        return this.numeric_values.length === 0 ? this.categorical_values : this.numeric_values;
    }
    load(values, field, colors) {
        this.zero();
        this.colors = colors;
        this.edge_count = colors.length + 1;
        this.selected_field = field;
        if (values.every(v => typeof v === "number")) {
            this.numeric_values = values;
        }
        else {
            this.categorical_values = values;
        }
    }
    get_bounds() {
        return this.boundaries;
    }
    get_color_map(gradient) {
        if (gradient) {
            this.create_gradient_map();
        }
        else {
            this.create_categorical_map();
        }
        this.set_counts();
        return this.color_map;
    }
    zero() {
        this.numeric_values = [];
        this.categorical_values = [];
        this.edge_count = 0;
        this.colors = [];
        this.boundaries = new ColorBoundaryContainer();
    }
    set_counts() {
        const parsed = this.values.map(v => this.color_map(v));
        for (let boundary of this.boundaries) {
            boundary.count = parsed.filter(c => c === boundary.color).length;
        }
    }
    calculate_edges() {
        let uniques = get_unique_values(this.values);
        const numericUniques = uniques.map(value => typeof value === "string" ? parseFloat(value) : value);
        if (numericUniques.length === 1) {
            return [numericUniques[0], numericUniques[0]];
        }
        const { max, min, ..._ } = MathHelper.get_stats(numericUniques);
        const [true_min, true_max] = [Math.min(...numericUniques), Math.max(...numericUniques)];
        if (min === max)
            return [true_min, true_max];
        const num_outlier_edges = (max < true_max ? 1 : 0) + (min > true_min ? 1 : 0);
        let main_edges = MathHelper.interpolate(min, max, this.edge_count - num_outlier_edges);
        if (num_outlier_edges === 0)
            return main_edges;
        if (min > true_min)
            main_edges.unshift(true_min);
        if (max < true_max)
            main_edges.push(true_max);
        return main_edges;
    }
    create_gradient_map() {
        let edges = this.calculate_edges();
        for (let i = 0; i < edges.length - 1; i++) {
            let interval_lower_bound = Math.round((edges[i]) * 100) / 100;
            let interval_upper_bound = Math.round(edges[i + 1] * 100) / 100;
            let ilb = this.keysToFormat.includes(this.selected_field) ? Math.round(interval_lower_bound).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }) : interval_lower_bound;
            let iub = this.keysToFormat.includes(this.selected_field) ? Math.round(interval_upper_bound).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }) : interval_upper_bound;
            const color_record = {
                label: `${ilb} - ${iub}`,
                color: this.colors[i],
                count: 0
            };
            this.boundaries.push(ColorBoundary.from(color_record));
        }
        this.color_map = (value) => {
            if (value == null)
                value = 0;
            let idx = 0;
            for (let i = 1; i < edges.length; i++) {
                if (value <= edges[i])
                    break;
                idx = i;
            }
            return this.colors[idx];
        };
    }
    create_categorical_map() {
        let i = 0;
        let itercolors = {
            next: () => this.colors[i++ % this.colors.length]
        };
        let uniques = get_unique_values(this.values);
        for (let val of uniques) {
            let color_record = {
                label: this.keysToFormat.includes(this.selected_field) ? Math.round(val).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }) : val === null || val === void 0 ? void 0 : val.toString(),
                color: itercolors.next(),
                count: 0
            };
            this.boundaries.push(ColorBoundary.from(color_record));
        }
        this.color_map = (val) => {
            let record;
            if (this.keysToFormat.includes(this.selected_field)) {
                record = this.boundaries.find(b => b.label === Math.round(val).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }));
            }
            else {
                record = this.boundaries.find(b => b.label === (val === null || val === void 0 ? void 0 : val.toString()));
            }
            if (record)
                return record.color;
            return '#FFFFFF';
        };
    }
}
